import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ReactChipInput from "react-chip-input";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import {InputDisableView} from "@app/components/DisableView";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import {cloneDeep} from "lodash";
import { 
    CANDIDATE_CATEGORY_FIELDS, 
    INDUSTRY_FUNCTIONS, 
    LATEST_STABLE_LEVELS,
    LOCAL_STORAGE_USER_LOGIN_INFO,
} from "@app/constants/Common";
import { checkExistsCommonFieldValues } from '@app/utils/CandidateUtils';
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {toast} from "react-toastify";
import * as CandidateService from "@app/services/CandidateService";

const CategoriesCard = ({
    initialCategories,
    candidateId,
    onChange,
    allInputInfo,
    mode = 'Edit', // Default to Edit mode for backward compatibility
    isEditCategories = false
}) => {
    const [isEdit, setIsEdit] = useState(isEditCategories);
    const [categories, setCategories] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        setCategories(initialCategories || {});
    }, [initialCategories]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, []);


    const onChangeCategoryItem = (event, field) => {
        if (field === 'industry_function') {
            categories.industry_function = event;
        } else {
            categories[event.target.name] = event.target.value;
        }

        setCategories({...categories});
        if (onChange) {
            onChange(categories);
        }
    };

    const onAddCategoryItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(categories[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            categories[fieldName] = arr
            setCategories({...categories})

            if (onChange) {
                onChange(categories);
            }
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveCategoryItem = (index, fieldName) => {
        let arr = cloneDeep(categories[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            categories[fieldName] = arr
            setCategories({...categories})
            if (onChange) {
                onChange(categories);
            }
        }
    }

    const updateCandidateCategories = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        categories.allCandidateCategoriesInfo = allInputInfo.allCandidateCategoriesInfo
        if (checkExistsCommonFieldValues(categories, userLoginInfo.id)) {
            return;
        }
        // setIsLoading(true)
        CandidateService.updateCandidateCategoriesDetail({candidate_id: candidateId, categories: categories}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    const handleSave = () => {
        if (mode !== 'Search') {
            // In Search mode, automatically call onSave without changing edit state
            setIsEdit(false);
        }

        updateCandidateCategories();
    };

    // Auto-save in Search mode when categories change
    // useEffect(() => {
    //     if (mode === 'Search' && onSave) {
    //         onSave(categories);
    //     }
    // }, [categories, mode, onSave]);

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Phân loại</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => setIsEdit(false)}>
                                Cancel
                            </button>
                        }
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={handleSave}>
                                Save
                            </button>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => setIsEdit(true)}>
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body'>
                {CANDIDATE_CATEGORY_FIELDS.map((field, i) => {
                    let fieldValue = categories[field.key] ? categories[field.key] : []
                    if (field.key === 'industry_function') {
                        return <div className='input-group mt-3' key={`category_${field.key}`}>
                            <label className={'w-100'}><b>Industry Function (Linkedin)</b></label>
                            <div style={{width: '100%'}}>
                                <Select options={INDUSTRY_FUNCTIONS} isMulti
                                        isDisabled={!isEdit}
                                        value={categories.industry_function}
                                        onChange={value => {
                                            onChangeCategoryItem(value, 'industry_function');
                                        }}
                                />
                                <AllUserInputField
                                    arrInfo={allInputInfo.allCandidateCategoriesInfo}
                                    field='industry_function'/>
                            </div>
                        </div>
                    }

                    return <div className='input-group mt-3' key={`category_${field.key}`}>
                        <label className={'w-100'}>{field.label}</label>
                        <ReactChipInput
                            classes="class1 class2 w-100"
                            chips={fieldValue}
                            onSubmit={value => onAddCategoryItem(value, field.key)}
                            onRemove={index => onRemoveCategoryItem(index, field.key)}
                        />
                        {!isEdit && <InputDisableView width="100%" height="55%" />}
                        <AllUserInputField arrInfo={allInputInfo.allCandidateCategoriesInfo}
                                           field={field.key}/>
                    </div>
                })}
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Latest Stable Level</b></label>
                    <select className='form-control'
                            name={'latest_stable_level'}
                            disabled={!isEdit}
                            value={categories.latest_stable_level ? categories.latest_stable_level.toLowerCase() : ''}
                            onChange={event => onChangeCategoryItem(event)}>
                        {LATEST_STABLE_LEVELS.map((item, index) => {
                            return <option value={item.toLowerCase()} key={`lsl_${index}`}>{item}</option>
                        })}
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateCategoriesInfo}
                                       field='latest_stable_level'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Highest Level</b></label>
                    <select className={`form-control`}
                            disabled={!isEdit}
                            value={categories.highest_level ? categories.highest_level.toLowerCase() : ''}
                            name={'highest_level'}
                            onChange={event => onChangeCategoryItem(event)}>
                        {LATEST_STABLE_LEVELS.map((item, index) => {
                            return <option value={item.toLowerCase()} key={`hl_${index}`}>{item}</option>
                        })}
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateCategoriesInfo}
                                       field='highest_level'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>LEVEL mới làm</b></label>
                    <select className='form-control'
                            name={'new_work_level'}
                            disabled={!isEdit}
                            value={categories.new_work_level ? categories.new_work_level.toLowerCase() : ''}
                            onChange={event => onChangeCategoryItem(event)}>
                        {LATEST_STABLE_LEVELS.map((item, index) => {
                            return <option value={item.toLowerCase()} key={`nwl_${index}`}>{item}</option>
                        })}
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateCategoriesInfo}
                                       field='new_work_level'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>LEVEL chưa rõ</b></label>
                    <select className='form-control'
                            name={'unknown_level'}
                            disabled={!isEdit}
                            value={categories.unknown_level ? categories.unknown_level.toLowerCase() : ''}
                            onChange={event => onChangeCategoryItem(event)}>
                        {LATEST_STABLE_LEVELS.map((item, index) => {
                            return <option value={item.toLowerCase()} key={`ul_${index}`}>{item}</option>
                        })}
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateCategoriesInfo}
                                       field='unknown_level'/>
                </div>
            </div>
        </div>
    );
};

export default CategoriesCard;


